module.exports = __webpack_public_path__ + "static/img/kftp1.4918444.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/joinus/kftp1.png
// module id = HpYZ
// module chunks = 1